import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-grid content-grid--subpage" }

import Card from "@/components/layout/Card.vue";
import BackLinkTitle from "@/components/layout/BackLinkTitle.vue";
import Breadcrumbs from "@/components/layout/Breadcrumbs.vue";
import {useI18n} from "vue3-i18n";
import {computed} from "vue";
import {Guid} from "@/types";
import {useRoute} from "vue-router";
import DocumentForm from "@/components/forms/DocumentForm.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentForm',
  setup(__props) {

const {t} = useI18n()

const route = useRoute()

const documentId = computed(() => {
    let id = ""
    if (typeof route.params.id === 'string')
        id = route.params.id

    return id
})
const isEditMode = computed(() => Guid.isValid(documentId.value));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Breadcrumbs, {
      title: _unref(t)(`routes.coproperty.children.${!isEditMode.value ? 'add' : 'edit'}Document.name`)
    }, null, 8, ["title"]),
    _createVNode(BackLinkTitle, {
      title: _unref(t)(`routes.coproperty.children.${!isEditMode.value ? 'add' : 'edit'}Document.name`)
    }, null, 8, ["title"]),
    _createVNode(Card, null, {
      default: _withCtx(() => [
        _createVNode(DocumentForm, { id: documentId.value }, null, 8, ["id"])
      ]),
      _: 1
    })
  ]))
}
}

})